import React, { useEffect, useLayoutEffect, useState } from "react";
import CartLeftContent from "../Cart/CartLeftContent/CartLeftContent";
import CartRightContent from "../Cart/CartRightContent/CartRightContent";
import System from "src/helper/system";
import FadeInOut from "../../component/Global/FadeInOut";
import AxiosSingletonLoader from "../../component/Global/AxiosSingletonLoader";
import { useCartStore } from "src/hooks/cart";
import { __set, __remove } from "src/store/axios_indicator";
import liveAuth from "src/helper/liveAuth";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import Helper from "src/helper/Helper";

export function Cart() {
  const [{ }, { initiatedKernelCall, get_Validate_Cart_From_Server, merge_Guest_Cart_Items, fetch_cart_data }, { }] = useCartStore();
  const isFromCart = System.isCallFromCart();
  const [__check] = useAxiosIndicatorCheck();
  const { avUserInfoData: { currentUser }, storageName: { GUEST_SESSION_ID, SUCCESS_PAGE }} = System
   const [monitorFunctionCall, setMonitorFunctionCall] = useState({
        monitorJs: false,
        frameworkReady: false
      });

  const fetchFromServer = async () => {
    async function fetchHere() {
      await Promise.all([
        // initiatedKernelCall({ minicart: false })
        fetch_cart_data()
      ]).then((res) => {
        if (!monitorFunctionCall?.frameworkReady) {
          System.monitorFrameWorkReady()
          setMonitorFunctionCall({...monitorFunctionCall, frameworkReady: true})
        }
       get_Validate_Cart_From_Server({ shipToAddressId: System.getUserShippingAddress() }).then(res => {
        if (!monitorFunctionCall?.monitorJs) {
          System.monitorJSDx()
          setMonitorFunctionCall({...monitorFunctionCall, monitorJs: true})
        }
        })
      }).catch(() => { });
    }

    __set('CART_API_CALL');
    __set('VIEW_CART_API_CALL');
    if (isFromCart && liveAuth.check() && localStorage.getItem(GUEST_SESSION_ID)) {
      const res = await merge_Guest_Cart_Items()
      if (res?.payload?.isSuccessFull) {
        localStorage.removeItem(GUEST_SESSION_ID)
        await fetchHere()
      }
    } else {
      await fetchHere()
    }

    __remove('CART_API_CALL');
    __remove('VIEW_CART_API_CALL');

  };

  useLayoutEffect(() => {
    async function fetchHere() {
      await fetchFromServer();
    }
    fetchHere();
  }, [])

  useEffect(() => {
    sessionStorage.removeItem(SUCCESS_PAGE)
    Helper.feedBackButtonScript()
   }, []);

  return (
    <>
      <div className="logged-screen cart-container">
        <div className="container">
          <FadeInOut show={true} duration={100}>
            <div className={"bs5 row"}>
              <CartLeftContent />
              <CartRightContent />
            </div>
          </FadeInOut>
          <div className={"bs5 row"}>
            <AxiosSingletonLoader />
          </div>
        </div>
      </div>
    </>
  );
}
